export enum ADDRESS_INGESTION_FILE_STATUS {
  INPROGRESS = 'IN_PROGRESS',
  DONE = 'DONE'
}
